const enhancedScrollers = new WeakSet();

/** @param {HTMLElement} scroller */
function enhanceScroller(scroller) {
  if (enhancedScrollers.has(scroller)) return;
  enhancedScrollers.add(scroller);

  let drag = null;
  let suppressClick = false;

  const syncScrollbar = () => {
    const scrollbar = scroller.parentElement?.querySelector('.fenza-product-color-option__scrollbar');
    if (!(scrollbar instanceof HTMLElement)) return;

    const maxScroll = scroller.scrollWidth - scroller.clientWidth;
    scrollbar.toggleAttribute('data-inactive', maxScroll <= 1);
    if (maxScroll <= 1) {
      scrollbar.style.setProperty('--fenza-color-thumb-width', '100%');
      scrollbar.style.setProperty('--fenza-color-thumb-offset', '0px');
      return;
    }

    const trackWidth = scrollbar.clientWidth;
    const thumbWidth = Math.max(18, trackWidth * (scroller.clientWidth / scroller.scrollWidth));
    const thumbOffset = (scroller.scrollLeft / maxScroll) * (trackWidth - thumbWidth);
    scrollbar.style.setProperty('--fenza-color-thumb-width', `${thumbWidth}px`);
    scrollbar.style.setProperty('--fenza-color-thumb-offset', `${thumbOffset}px`);
  };

  scroller.addEventListener('pointerdown', (event) => {
    if (event.pointerType !== 'mouse' || event.button !== 0 || scroller.scrollWidth <= scroller.clientWidth) return;
    drag = {
      pointerId: event.pointerId,
      startX: event.clientX,
      startScrollLeft: scroller.scrollLeft,
      moved: false,
    };
    document.addEventListener('pointermove', moveDrag, { passive: false, capture: true });
    document.addEventListener('pointerup', endDrag, true);
    document.addEventListener('pointercancel', endDrag, true);
  });

  const moveDrag = (event) => {
    if (!drag || drag.pointerId !== event.pointerId) return;
    const distance = event.clientX - drag.startX;
    if (!drag.moved && Math.abs(distance) < 4) return;
    drag.moved = true;
    scroller.classList.add('is-dragging');
    scroller.scrollLeft = drag.startScrollLeft - distance;
    event.preventDefault();
  };

  scroller.addEventListener('dragstart', (event) => {
    event.preventDefault();
  });

  const endDrag = (event) => {
    if (!drag || drag.pointerId !== event.pointerId) return;
    suppressClick = drag.moved;
    scroller.classList.remove('is-dragging');
    drag = null;
    document.removeEventListener('pointermove', moveDrag, true);
    document.removeEventListener('pointerup', endDrag, true);
    document.removeEventListener('pointercancel', endDrag, true);
    setTimeout(() => {
      suppressClick = false;
    }, 0);
  };

  scroller.addEventListener(
    'click',
    (event) => {
      if (!suppressClick) return;
      suppressClick = false;
      event.preventDefault();
      event.stopImmediatePropagation();
    },
    true
  );

  scroller.addEventListener(
    'wheel',
    (event) => {
      if (scroller.scrollWidth <= scroller.clientWidth || Math.abs(event.deltaX) >= Math.abs(event.deltaY)) return;
      scroller.scrollLeft += event.deltaY;
      event.preventDefault();
    },
    { passive: false }
  );

  scroller.addEventListener('scroll', syncScrollbar, { passive: true });
  new ResizeObserver(syncScrollbar).observe(scroller);
  requestAnimationFrame(syncScrollbar);
}

/** @param {ParentNode} root */
function enhanceColorScrollers(root = document) {
  root.querySelectorAll('[data-fenza-color-scroller]').forEach((element) => {
    if (element instanceof HTMLElement) enhanceScroller(element);
  });
}

enhanceColorScrollers();
new MutationObserver((mutations) => {
  for (const mutation of mutations) {
    for (const node of mutation.addedNodes) {
      if (!(node instanceof HTMLElement)) continue;
      if (node.matches('[data-fenza-color-scroller]')) enhanceScroller(node);
      enhanceColorScrollers(node);
    }
  }
}).observe(document.documentElement, { childList: true, subtree: true });
